module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER, _vm.USER_ROLES.GIS_USER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER,USER_ROLES.GIS_USER]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "sorting"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusValue),
      expression: "statusValue"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.fiteredResult]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "scheduled"
    }
  }, [_vm._v("Scheduled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ongoing"
    }
  }, [_vm._v("Ongoing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "completed"
    }
  }, [_vm._v("Completed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cancelled"
    }
  }, [_vm._v("Cancelled")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn inline",
    on: {
      "click": _vm.clearStatus
    }
  }, [_vm._v("Clear")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
      expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'TripCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn addnew"
  }, [_vm._v("Add New")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "permission",
            rawName: "v-permission.if",
            value: ([_vm.USER_ROLES.ADMIN, _vm.USER_ROLES.SUPER_ADMIN, _vm.USER_ROLES.GA_HEAD, _vm.USER_ROLES.JOURNEY_MANAGER]),
            expression: "[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]",
            modifiers: {
              "if": true
            }
          }]
        }, [(props.row.status == 'ongoing') ? _c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.UpdateDestination(props.row)
            }
          }
        }) : _vm._e()])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a7c5c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip/Trip.vue
// module id = 2262
// module chunks = 1